import { render, staticRenderFns } from "./comparison_pane.vue?vue&type=template&id=6fe4bc00&"
import script from "./comparison_pane.vue?vue&type=script&lang=js&"
export * from "./comparison_pane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports